// removed by extract-text-webpack-plugin
module.exports = {"User":"User__User__2u_p2","UserInner":"User__UserInner__wL76A","UserInner2":"User__UserInner2__1DXJ_","Btn":"User__Btn__3ux5M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserController/User/User.css
// module id = 97
// module chunks = 0